const CREATE_LAB = "CREATE_LAB";
const CREATE_LAB_SUCCESS = "CREATE_LAB_SUCCESS";
const CREATE_LAB_ERROR = "CREATE_LAB_ERROR";
const UPDATE_LAB = "UPDATE_LAB";
const UPDATE_LAB_SUCCESS = "UPDATE_LAB_SUCCESS";
const UPDATE_LAB_ERROR = "UPDATE_LAB_ERROR";
const FETCH_LAB = "FETCH_LAB";
const FETCH_LAB_SUCCESS = "FETCH_LAB_SUCCESS";
const FETCH_LAB_ERROR = "FETCH_LAB_ERROR";
const LAB_DETAILS_IS_EDIT = "LAB_DETAILS_IS_EDIT";
const ADD_USER_IN_MANAGER = "ADD_USER_IN_MANAGER";
const FETCH_LABS_UTIL_DATA = "FETCH_LABS_UTIL_DATA";
const FETCH_LABS_UTIL_DATA_SUCCESS = "FETCH_LABS_UTIL_DATA_SUCCESS";
const FETCH_ALL_LABS = "FETCH_ALL_LABS";
const FETCH_ALL_LABS_SUCCESS = "FETCH_ALL_LABS_SUCCESS";
const FETCH_ALL_LABS_ERROR = " FETCH_ALL_LABS_ERROR"
const DELETE_LAB = "DELETE_LAB";
const DELETE_LAB_SUCCESS = "DELETE_LAB_SUCCESS";
const DELETE_LAB_ERROR = "DELETE_LAB_ERROR";
const DELETE_LAB_ATTACH = "DELETE_LAB_ATTACH";
const DELETE_LAB_ATTACH_SUCCESS = "DELETE_LAB_ATTACH_SUCCESS";
const DELETE_LAB_ATTACH_ERROR = "DELETE_LAB_ATTACH_ERROR";
const LAB_DETAIL_CLEANUP_FUNC = "LAB_DETAIL_CLEANUP_FUNC";
const LAB_NOTIF_IS_EDIT = "LAB_NOTIF_IS_EDIT";
const UPDATE_LAB_NOTIFICATION = "UPDATE_LAB_NOTIFICATION";
const UPDATE_LAB_NOTIFICATION_SUCCESS =
  "UPDATE_LAB_NOTIFICATION_SUCCESS";
const UPDATE_LAB_NOTIFICATION_ERROR = "UPDATE_LAB_NOTIFICATION_ERROR";
const DELETE_STOCK_NOTIFICATION_RECIPIENT = "DELETE_STOCK_NOTIFICATION_RECIPIENT";
const DELETE_STOCK_NOTIFICATION_RECIPIENT_SUCCESS = "DELETE_STOCK_NOTIFICATION_RECIPIENT_SUCCESS";
const DELETE_STOCK_NOTIFICATION_RECIPIENT_ERROR = "DELETE_STOCK_NOTIFICATION_RECIPIENT_ERROR";
const FETCH_LAB_USERS = "FETCH_LAB_USERS";
const FETCH_LAB_USERS_SUCCESS = "FETCH_LAB_USERS_SUCCESS";
const FETCH_LAB_USERS_ERROR = "FETCH_LAB_USERS_ERROR";
const FETCH_LAB_USERS_MAP = "FETCH_LAB_USERS_MAP";
const FETCH_LAB_USERS_MAP_SUCCESS = "FETCH_LAB_USERS_MAP_SUCCESS";
const FETCH_LAB_USERS_MAP_ERROR = "FETCH_LAB_USERS_MAP_ERROR";
const FETCH_WAREHOUSES = "FETCH_WAREHOUSES";
const FETCH_WAREHOUSES_SUCCESS = "FETCH_WAREHOUSES_SUCCESS";
const FETCH_WAREHOUSES_ERROR = "FETCH_WAREHOUSES_ERROR";


export {
  CREATE_LAB,
  CREATE_LAB_SUCCESS,
  CREATE_LAB_ERROR,
  UPDATE_LAB,
  UPDATE_LAB_SUCCESS,
  UPDATE_LAB_ERROR,
  FETCH_LAB,
  FETCH_LAB_SUCCESS,
  FETCH_LAB_ERROR,
  ADD_USER_IN_MANAGER,
  LAB_DETAILS_IS_EDIT,
  FETCH_LABS_UTIL_DATA,
  FETCH_LABS_UTIL_DATA_SUCCESS,
  FETCH_ALL_LABS,
  FETCH_ALL_LABS_SUCCESS,
  FETCH_ALL_LABS_ERROR,
  DELETE_LAB,
  DELETE_LAB_SUCCESS,
  DELETE_LAB_ERROR,
  DELETE_LAB_ATTACH,
  DELETE_LAB_ATTACH_SUCCESS,
  DELETE_LAB_ATTACH_ERROR,
  LAB_DETAIL_CLEANUP_FUNC,
  LAB_NOTIF_IS_EDIT,
  UPDATE_LAB_NOTIFICATION,
  UPDATE_LAB_NOTIFICATION_SUCCESS,
  UPDATE_LAB_NOTIFICATION_ERROR,
  DELETE_STOCK_NOTIFICATION_RECIPIENT,
  DELETE_STOCK_NOTIFICATION_RECIPIENT_SUCCESS,
  DELETE_STOCK_NOTIFICATION_RECIPIENT_ERROR,
  FETCH_LAB_USERS,
  FETCH_LAB_USERS_SUCCESS,
  FETCH_LAB_USERS_ERROR,
  FETCH_LAB_USERS_MAP,
  FETCH_LAB_USERS_MAP_SUCCESS,
  FETCH_LAB_USERS_MAP_ERROR,
  FETCH_WAREHOUSES,
  FETCH_WAREHOUSES_SUCCESS,
  FETCH_WAREHOUSES_ERROR,
};
